import { IAuthorizationContext } from 'portal/src/auth/IAuthorizationContext';
import useAuth from 'portal/src/auth/useAuth';
import Dashboard from 'portal/src/components/common/Dashboard';
import forbiddenResponse from 'portal/src/navigation/responses/forbiddenResponse';

export default function FeatureEnabledDashboard({
  slug,
  disabledSlug,
  isFeatureEnabled,
}: {
  slug: string;
  disabledSlug?: string;
  isFeatureEnabled: (context: IAuthorizationContext) => boolean;
}): React.ReactElement {
  const { featureChecker } = useAuth();
  const tabEnabled = isFeatureEnabled({
    featureChecker,
  } as IAuthorizationContext);

  if (tabEnabled) {
    return <Dashboard dashboardSlug={slug} />;
  }

  if (disabledSlug) {
    return <Dashboard dashboardSlug={disabledSlug} />;
  }

  throw forbiddenResponse();
}
